import { PricePeriodDetail } from '@features/TimberBuyer/SalesAgreements/PricePeriods/PricePeriodDetail'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const PricePeriodDetailRoute: React.FC = () => {
  const { timberBuyerId, salesAgreementId, pricePeriodId } = Route.useParams()

  return (
    <PricePeriodDetail
      timberBuyerId={timberBuyerId}
      salesAgreementId={salesAgreementId}
      pricePeriodId={pricePeriodId}
    />
  )
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/',
)({
  component: PricePeriodDetailRoute,
  staticData: {
    breadcrumb: t('timberbuyer-salesagreements-priceperiods.detail.breadcrumb'),
  },
})
